<template>
    <div id="app">
        <div>
            <router-view name="header"/>
            <router-view ref="container"/>
            <router-view name="footer"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "App",
        data: () => ({

        }),
        mounted(){

        },
        created() {

        },
        methods: {

        }
    };

    (function (win, doc) {
        if (!win.addEventListener) return
        let html = document.documentElement
        function setFont() {
            let cliWidth = document.body.clientWidth
            html.setAttribute('style', 'font-size: ' + 100 * (cliWidth / 750) + 'px');
        }
        win.addEventListener('resize', setFont, false);
        doc.addEventListener('DOMContentLoaded', setFont, false)
    })(window, document)
</script>



// WEBPACK FOOTER //
// src/App.vue